import React, { useEffect, useState } from 'react';
import mammoth from 'mammoth';
import PDFRenderer from './PDFRenderer';

const DocRenderer = ({ file }) => {
  const [docContent, setDocContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const renderDoc = async () => {
      if (!file) {
        setError('No file provided.');
        setLoading(false);
        return;
      }

      try {
        const fileType = file.type;

        if (fileType === 'application/pdf') {
          // For PDF files
          setDocContent(<PDFRenderer file={file} />);
        } else if (
          fileType === 'application/msword' ||
          fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ) {
          // For Word files
          const reader = new FileReader();
          reader.onload = async (event) => {
            try {
              const arrayBuffer = event.target.result;
              const result = await mammoth.convertToHtml({ arrayBuffer });
              setDocContent(
                <div
                  dangerouslySetInnerHTML={{ __html: result.value }}
                  className="prose max-w-none"
                />
              );
            } catch (error) {
              setError('Error converting Word file.');
            }
          };
          reader.readAsArrayBuffer(file);
        } else if (fileType === 'text/plain') {
          // For plain text files
          const reader = new FileReader();
          reader.onload = (event) => {
            const textContent = event.target.result;
            setDocContent(<pre className="whitespace-pre-wrap">{textContent}</pre>);
          };
          reader.readAsText(file);
        } else {
          setDocContent(<div>Unsupported file type.</div>);
        }
      } catch (error) {
        setError('Error reading file.');
      } finally {
        setLoading(false);
      }
    };

    renderDoc();
  }, [file]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <span>Loading...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-500">
        {error}
      </div>
    );
  }

  return <div className="w-full border rounded">{docContent}</div>;
};

export default DocRenderer;
